import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'process-alarms',
    template: '',
    standalone: false
})
export class ReadAndWriteDatapointExampleAlarm implements CodeSnippet{

    text : string = $localize`:@@script-editor.code-example.process-alarm-script:Process alarm scripts`;

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function alarmmain()

    -- iterate alarms
    for alarm in alarms() do

        -- OPTIONAL: get the plant object for read/write of datapoints
        local plant = getplant()

        -- handle specific alarm 'Leetspeak'
        if alarm.alarmId == "1337" then

            -- attach rootcauses and/or override priority or resetType to alarmtype
            alarm.addRootCause(

                -- multiple rootcauses
                {
                    "dee8d60a-5266-4cdd-8292-d8faa203ecfe", -- RootCause: 'Network error'
                    "0e3c13e7-c7c6-460c-8864-65f90eb8de2e"  -- RootCause: 'Sensor failure'
                },

                -- priority override
                3,

                -- resetType override
                "MANUAL"
            )
            
        end
        
    end
        
end
`
    }
}